export interface ITxTransport {
  send(payload: string): Promise<void>;
}

export interface IRxTransport {
  onReceive(handler: (payload: string) => void): () => void;
}

export enum CommandResponseMode {
  NONE,
  ACK,
  DATA,
  ACK_OR_DATA,
}

export interface DeviceCommand {
  name: string;
  payload: string;
  responseMode: CommandResponseMode;
  timeoutMs: number;
  maxRetries: number;
  retryOnBusy: boolean;
}
